import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import styled, { keyframes } from 'styled-components';
import { fontMono } from '../../theme/config';
import media from '../../theme/media';
import { ContainerLarge, Figure } from '../../theme/grid';
import { HeadingH1, HeadingH2} from '../../theme/typography';

const dashButton = keyframes`
  to { stroke-dashoffset: 0; }
`;

const HeaderContainer = styled.header`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.5rem 2rem;
  position: absolute;
  top: 0;
  
  &.false {
      a .button-present {
          .strokeBorder {
            stroke-dashoffset: 0;
          }
          &.mozilla {
            .strokeBorder { fill: rgba(255, 9, 0, .05);; }
            .iconColor { stroke: #FF0900; }
          }
          &.everyaction {
            .strokeBorder { fill: rgba(0, 119, 255, .05); }
            .iconColor { stroke: #0077FF; }
          }
          &.amazon {
            .strokeBorder { fill: rgba(0, 0, 0, .05); }
            .iconColor { stroke: #f86b01; }
          }
          &.skwiz {
            .strokeBorder { fill: rgba(72, 92, 220, .05); }
            .iconColor { stroke: #485CDC; }
          }
          &.default {
            .strokeBorder { fill: rgba(0, 0, 0, .05); }
            .iconColor { stroke: #000000; }
          }
      }
  }
  
  nav {
    float: right;
  }
  svg {
    vertical-align: middle;
  }
  a {
    font-size: 1rem;
    vertical-align: middle;
    color: #0077FF;
    font-family: ${fontMono};
    position: relative;
    font-weight: 600;
    line-height: 36px;
    width: fit-content;
    width: -moz-fit-content;
    display: inline-block;
    text-transform: uppercase;
    letter-spacing: 1px;
    
    .arrow {
      width: 24px;
      margin: 6px;
      opacity: .5;
      ${media.phone`
        margin: 0;
        display: none;
      `}
    }
    
    .logo {
      height: 24px;
      margin: 6px;
      ${media.phone`
        margin: 0;
      `}
    }
    
    .button-present {
      height: 40px;
      letter-spacing: normal;
      text-transform: none;
      font-weight: 400;
      box-shadow: 0 1px 2px rgba(0, 0, 0, .1);
      border-radius: 4px;
      
      &.mozilla .strokeBorder {
          stroke: #FF0900;
      }
      &.everyaction .strokeBorder {
          stroke: #0077FF;
      }
      &.amazon .strokeBorder {
          stroke: #f86b01;
      }
      &.skwiz .strokeBorder {
          stroke: #485CDC;
      }
      &.default .strokeBorder {
          stroke: #000000;
      }
      
      .strokeBorder {
        stroke-dasharray: 348;
        stroke-dashoffset: 348;
      }
      &:hover {
        .strokeBorder {
          animation: ${dashButton} .5s linear forwards;
        }
        &.mozilla .iconColor {
            stroke: #FF0900;
        }
        &.everyaction .iconColor {
            stroke: #0077FF;
        }
        &.amazon .iconColor {
            stroke: #f86b01;
        }
        &.skwiz .iconColor {
            stroke: #485CDC;
        }
        &.default .iconColor {
            stroke: #000000;
        }
      }
    }
    
    
    &.tldr {
      border: 1px solid #CED4DA;
      border-radius: 4px;
      background: white;
      padding: 0 12px;
    }
    
    span {
      position: relative;
      display: inline-block;
      &:after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 0%;
        border-bottom: 2px solid #0077FF;
        transition: 0.4s;
      }
    }
    &:hover span:after { width: 100%; }
  }
  &.mozilla a {
      color: #FF0900;
      span:after {
        border-bottom: 2px solid #FF0900;
      }
  }
  &.everyaction a {
      color: #0077FF;
      span:after {
        border-bottom: 2px solid #0077FF;
      }
  }
  &.skwiz a {
      color: #485CDC;
      span:after {
        border-bottom: 2px solid #485CDC;
      }
  }
  &.amazon a {
      color: #f86b01;
      span:after {
        border-bottom: 2px solid #f86b01;
      }
  }
  &.default a {
      color: #000000;
      span:after {
        border-bottom: 2px solid #000000;
      }
  }
  ${media.phone`
    padding: 1rem;
  `}
`;

const HideMobile = styled.div`
  display: inline;
  ${media.phone`
    display: none !important;
  `}
`;

const HeaderSection = styled.div`
  margin: 0 16px;
  display: inline-block;
`;

const HeaderSubtitle = styled.span`
  font-size: 14px;
  color: #0077FF;
  font-family: ${fontMono};
  font-weight: 600;
  line-height: 16px;
  width: fit-content;
  width: -moz-fit-content;
  display: block;
  text-transform: uppercase;
  letter-spacing: 1px;
  
  &.mozilla {
    color: #FF0900;
  }
  &.skwiz {
    color: #485CDC;
  }
  &.default {
    color: #000000;
  }
  &.amazon {
    color: #f86b01;
  }
  
`;

const HeaderDescription = styled.span`
  font-size: 16px;
`;

export const Overlay = styled.div`
    height: calc(100vh - 176px);
    top: 88px;
    position: fixed;
    width: 100%;
    display: none;
    &.true {
      display: flex;
    }
`;

export const OverlayContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    
    div:first-child {
      width: 30%;
    }
    
    div:last-child {
      width: 60%;
    }
`;

class Header extends Component {
  
  constructor() {
    super();
  }
  
  render() {
    return (
          <HeaderContainer className={this.props.theme}>
              <Link to="/">
                  <svg className="arrow" focusable="false" viewBox="0 0 24 24"><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"></path></svg>
                  <svg className="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 168 48"><g fill="none" fill-rule="evenodd" stroke="#000" stroke-linecap="round" stroke-width="3.40909091"><path class="animate-m" stroke-linejoin="round" d="M3 21.2034632C51-2.93217893 61.6515152-.32611833 34.9545455 29.021645c-40.04545459 44.021645 61.4545454-42.9545454 27.3636363-.6818182-34.0909091 42.2727273 38.8636364-27.27272723 20.4545455 0C70.5 46.521645 76.8636364 46.9761905 101.8636364 29.7034632c-4.1232207 12.043835-3.4414025 15.4392526 2.0454546 10.1862528 5.486857-5.2529999 12.305039-15.8287574 20.454545-31.72727275"></path><path class="animate-i" d="M103.909091 23.1624432l2.045454-4.090909"></path><path class="animate-k" stroke-linejoin="round" d="M125.090909 25.2078978C116 31 105.318182 34.7533523 113.5 40.889716 121.681818 47.0260796 149 33 137 32s-10 21 27 4"></path></g></svg>
              </Link>
              <Link to="#" onClick={this.props.action} style={{display: "none"}}>
                  <svg className={this.props.theme + " button-present"} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 114 40">
                      <g fill="none" fill-rule="evenodd">
                          <rect width="113" height="39" x=".5" y=".5" fill="#FFF" stroke="#CED4DA" rx="4"/>
                          <rect className="strokeBorder" width="113" height="39" x=".5" y=".5" fill="#FFF" stroke="#CED4DA" rx="4"  stroke-width="3"/>
                          <text fill="#1E1F21" font-family="IBMPlexSans-Medium, IBM Plex Sans" font-size="14" font-weight="400">
                              <tspan x="48" y="26">Present</tspan>
                          </text>
                          <path className="iconColor" stroke="#909090" stroke-width="2" d="M13 27V17c0-1.1045695.8954305-2 2-2h16c1.1045695 0 2 .8954305 2 2v10c0 1.1045695-.8954305 2-2 2H15c-1.1045695 0-2-.8954305-2-2z"/>
                          <path className="iconColor" stroke="#909090" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 11h16c1.1045695 0 2 .8954305 2 2v10h0"/>
                      </g>
                  </svg>
              </Link>
          </HeaderContainer>
    );
  }
}
export default Header;



// WEBPACK FOOTER //
// src/components/Header/Header.js